import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { SIZES, PRIORITIES, SKINS } from './constants';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import _Symbol from '../symbol/symbol';
var IconButton = /*#__PURE__*/function (_React$PureComponent) {
  function IconButton() {
    _classCallCheck(this, IconButton);
    return _callSuper(this, IconButton, arguments);
  }
  _inherits(IconButton, _React$PureComponent);
  return _createClass(IconButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        dataHook = _this$props.dataHook,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        skin = _this$props.skin,
        automationId = _this$props.automationId,
        children = _this$props.children,
        size = _this$props.size,
        priority = _this$props.priority,
        getClassName = _this$props.getClassName;
      var finalSkin = "".concat(skin.toLowerCase(), "-").concat(priority.toLowerCase());
      var finalSize = size === SIZES.MEDIUM || size === SIZES.LARGE ? "icon-btn-size-".concat(size.toLowerCase()) : '';
      return /*#__PURE__*/React.createElement("button", {
        className: getClassName("control-icon-button ".concat(finalSkin, " ").concat(finalSize)),
        "data-aid": automationId,
        "data-hook": dataHook,
        disabled: disabled,
        onClick: onClick
      }, /*#__PURE__*/React.createElement(_Symbol, null, children));
    }
  }]);
}(React.PureComponent);
IconButton.displayName = displayNames.ICON_BUTTON;
IconButton.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** make the component to be disabled and stop click events */
  disabled: PropTypes.bool,
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** triggered when button is clicked */
  onClick: PropTypes.func,
  /** changing the look of the component  */
  skin: PropTypes.oneOf(['light', 'light-dark', 'standard', 'premium']),
  /** changing the size of the component  */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /** changing the priority of the component  */
  priority: PropTypes.oneOf(['primary', 'secondary', 'inverted'])
};
IconButton.defaultProps = {
  skin: SKINS.STANDARD,
  priority: PRIORITIES.PRIMARY,
  size: 'small'
};
export default compose(IconButton);